import { Users } from "lucide-react";
import { Card, CardContent, CardHeader } from "@/components/ui/card";

export function Connections() {
  return (
    <Card>
      <CardHeader className="flex flex-row items-center justify-between pb-2">
        <div className="flex items-center gap-2">
          <p className="text-[10px] font-bold text-content-muted uppercase tracking-[2px]">
            Connections
          </p>
          <span className="rounded-md border border-content-border text-content-muted text-[10px] font-semibold px-2 py-0.5 uppercase tracking-wider">
            Soon
          </span>
        </div>
      </CardHeader>
      <CardContent className="flex flex-col items-center justify-center py-6 text-center">
        <div className="w-12 h-12 rounded-xl border border-dashed border-content-border flex items-center justify-center mb-3">
          <Users className="w-5 h-5 text-content-muted" />
        </div>
        <p className="text-xs text-content-muted leading-relaxed font-serif">
          Connect with other participants in your programme
        </p>
      </CardContent>
    </Card>
  );
}
